import { AfterViewInit, ChangeDetectorRef, Component, Input } from '@angular/core';
import { CalendarioSpettacolo, Spettacolo } from '../../shared/interface';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-button-spettacolo',
  templateUrl: './button-spettacolo.component.html',
  styleUrl: './button-spettacolo.component.css'
})
export class ButtonSpettacoloComponent implements AfterViewInit {

  constructor(private cdr: ChangeDetectorRef, private datePipe: DatePipe) { }

  @Input('spettacolo') spettacolo?: Spettacolo;
  @Input('calendario') calendario: CalendarioSpettacolo[] = [];
  @Input('classi') classi?: string = '';

  href: string | undefined = '';
  href_custom: string | undefined = '';
  testo: string = 'acquista biglietti';
  testo_custom: string = 'acquista su dice';

  visible: boolean = true;  
  disable: boolean = false;

  ngAfterViewInit(): void {

    // Recupero il link per il pulsante
    if (this.spettacolo?.webshop)
      this.href = this.spettacolo?.link_webshop;
    if (this.spettacolo?.custom)
      this.href_custom = this.spettacolo?.link_custom;              

    // Recupero il testo
    if (this.spettacolo?.sold_out)
      this.testo = 'sold out';
    if (this.spettacolo?.gratuito)
      this.testo = 'prenota subito';
    if (this.spettacolo?.annullato)
      this.testo = 'annullato';
    if (this.spettacolo?.soon_in_vendita)
      this.testo = 'a breve in vendita';
    if (this.spettacolo?.in_vendita_dal)
      this.testo = 'in vendita dal ' + this.datePipe.transform(this.spettacolo?.in_vendita_dal_data, 'dd MMM');

    // Disabilito il pulsante
    this.disable = this.spettacolo?.sold_out || this.spettacolo?.annullato || this.spettacolo?.soon_in_vendita || this.spettacolo?.in_vendita_dal || false;    

    // Controllo se è già stato effettuato lo spettacolo    
    const date = this.calendario.length > 0 && this.calendario.length <= 1 ? this.datePipe.transform(this.calendario[0].data, 'yyyy-MM-dd') + " " + this.calendario[0].orario : (this.calendario.length == 0 ? this.datePipe.transform(this.spettacolo!.al, 'yyyy-MM-dd') : this.datePipe.transform(this.calendario[this.calendario.length - 1].data, 'yyyy-MM-dd') + " " + this.calendario[this.calendario.length - 1].orario)            
    const time = new Date(date || '').getTime() - new Date().getTime();
    if (time < 300000)
      this.visible = false
    
    this.cdr.detectChanges();

  }
}
